import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    linkDebitCardTitle: {
        id: '_.link_debit_card.title',
        defaultMessage: 'Link your debit card'
    },
    editDebitCardTitle: {
        id: '_.modal.edit_debit_card_title',
        defaultMessage: 'Edit debit card'
    },
    cardNumber: {
        id: '_.link_debit_card.card_number',
        defaultMessage: 'Card number'
    },
    cardNumberError: {
        id: '_.link_debit_card.card_number_error',
        defaultMessage: 'Invalid card number'
    },
    cardTypeNotDebitError: {
        id: '_.link_debit_card.card_type_not_debit',
        defaultMessage: `Make sure you link a debit card`
    },
    cardTypeError: {
        id: '_.link_debit_card.card_type_error',
        defaultMessage: `Please enter a valid debit card`
    },
    cardError: {
        id: '_.link_debit_card.card_error',
        defaultMessage: 'This card has been declined. Please try another one.'
    },
    expiryDate: {
        id: '_.link_debit_card.expiry_date',
        defaultMessage: 'Expiry date'
    },
    expiryDateError: {
        id: '_.link_debit_card.expiry_date_error',
        defaultMessage: 'Invalid expiry date'
    },
    CVV: {
        id: '_.link_debit_card.cvv',
        defaultMessage: 'CVC'
    },
    CVVError: {
        id: '_.link_debit_card.cvv_error',
        defaultMessage: 'Invalid CVC'
    },
    billingPostcode: {
        id: '_.link_debit_card.billing_postcode',
        defaultMessage: 'Billing postcode'
    },
    billingPostcodeError: {
        id: '_.link_debit_card.billing_postcode_error',
        defaultMessage: 'Invalid postcode'
    },
    cardholderName: {
        id: '_.link_debit_card.cardholder_name',
        defaultMessage: 'Cardholder name'
    },
    linkDebitCardError: {
        id: '_.link_debit_card.error',
        defaultMessage: 'Failed to register the card. Please try again.'
    },
    scheduledRepaymentsText: {
        id: '_.link_debit_card.scheduled_repayments_text',
        defaultMessage:
            'Your scheduled repayments will come from this debit card.'
    },
    linkCardButton: {
        id: '_.link_debit_card.link_card',
        defaultMessage: 'Link this card for repayments'
    },
    successfulLinkText: {
        id: '_.link_debit_card.successful_link',
        defaultMessage:
            "Thanks! You've successfully linked your card! Continue to the next step"
    },
    cvvNumberTooltip: {
        id: '_.link_debit_card.cvv_number_tooltip',
        defaultMessage: 'The 3 digit number on the back of your card'
    }
});
